import { render, staticRenderFns } from "./keywordAnalysis.vue?vue&type=template&id=106bf87a&scoped=true"
import script from "./keywordAnalysis.vue?vue&type=script&lang=js"
export * from "./keywordAnalysis.vue?vue&type=script&lang=js"
import style0 from "./keywordAnalysis.vue?vue&type=style&index=0&id=106bf87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106bf87a",
  null
  
)

export default component.exports